import { styled } from '@mui/material';
import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

const CustomSvgIcon = styled(SvgIcon)(() => {
    return {
        color: 'transparent',
    };
});

export default forwardRef((props, ref) => {
    const id1 = uuid();
    const id2 = uuid();

    return (
        <CustomSvgIcon ref={ref} {...props}>
            <mask id={id1} style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
                <circle cx='12' cy='12' r='12' fill='#D9D9D9' />
            </mask>
            <g mask={`url(#${id1})`}></g>
            <mask id={id2} style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
                <circle cx='12' cy='12' r='12' fill='#D9D9D9' />
            </mask>
            <g mask={`url(#${id2})`}>
                <rect x='3.25836' width='17.3494' height='24' fill='white' />
                <rect x='-6.27686' width='11.5663' height='24' fill='#DC2626' />
                <path
                    d='M14.7042 14.6627C14.7562 14.6096 16.8922 12.7021 16.8922 12.7021L16.5283 12.543C16.3203 12.439 16.3743 12.299 16.4243 12.1738C16.4742 12.0125 16.8423 10.7458 16.8423 10.7458C16.8423 10.7458 15.8502 10.958 15.6422 11.011C15.4862 11.0619 15.4342 10.958 15.3822 10.8519C15.3302 10.7458 15.0703 10.1644 15.0703 10.1644C15.0703 10.1644 13.9762 11.4354 13.9242 11.4863C13.7162 11.6454 13.5062 11.4863 13.5582 11.2741C13.5582 11.0619 14.1322 8.52422 14.1322 8.52422C14.1322 8.52422 13.5062 8.89342 13.2982 8.99951C13.1422 9.1056 13.0361 9.1056 12.9321 8.89342C12.8261 8.73428 12.044 7.2002 12.044 7.2002C12.044 7.2002 11.2641 8.73428 11.1601 8.89342C11.0561 9.1056 10.9521 9.1056 10.794 8.99951C10.586 8.89342 9.95996 8.52422 9.95996 8.52422C9.95996 8.52422 10.534 11.0619 10.534 11.2741C10.586 11.4863 10.378 11.6454 10.168 11.4863C10.116 11.4332 9.02193 10.1644 9.02193 10.1644C9.02193 10.1644 8.76195 10.7437 8.70995 10.8497C8.65795 10.9558 8.60596 11.0598 8.44996 11.0089C8.2399 10.9558 7.24987 10.7437 7.24987 10.7437C7.24987 10.7437 7.61593 12.0104 7.66793 12.1716C7.71784 12.299 7.77192 12.4369 7.56393 12.5408L7.19995 12.7021C7.19995 12.7021 9.33392 14.6096 9.38799 14.6627C9.49407 14.7688 9.59598 14.8218 9.49407 15.1401C9.38799 15.4584 9.284 15.8848 9.284 15.8848C9.284 15.8848 11.2641 15.4584 11.4741 15.4053C11.6551 15.3862 11.8547 15.4584 11.8547 15.6705C11.8547 15.8827 11.7341 18.064 11.7341 18.064H12.3581C12.3581 18.064 12.2374 15.8848 12.2374 15.6705C12.2374 15.4562 12.435 15.3862 12.6201 15.4053C12.8281 15.4584 14.8082 15.8848 14.8082 15.8848C14.8082 15.8848 14.7042 15.4584 14.6002 15.1401C14.4962 14.8218 14.6002 14.7688 14.7042 14.6627Z'
                    fill='#DC2626'
                />
                <rect x='18.4839' width='11.5663' height='24' fill='#DC2626' />
            </g>
            <circle cx='12' cy='12' r='11.75' stroke='#D3D2D7' strokeWidth='0.5' />
        </CustomSvgIcon>
    );
});
